import { defineComponent as w, computed as u, useAttrs as A, openBlock as l, createElementBlock as d, unref as n, createTextVNode as C, toDisplayString as q, createCommentVNode as c, mergeProps as k, normalizeClass as z } from "vue";
import { c as B } from "./cn-Bje3WtSp.js";
import { u as F } from "./useId-DuhnX31i.js";
import { u as N } from "./formFieldContext-OfRFoILA.js";
const D = { class: "flex flex-col gap-1" }, E = ["for"], S = {
  key: 0,
  class: "text-danger",
  "aria-hidden": "true"
}, P = ["id", "name", "value", "placeholder", "disabled", "readonly", "required", "rows", "aria-invalid", "aria-describedby", "aria-required"], R = ["id", "type", "name", "value", "placeholder", "disabled", "readonly", "required", "autocomplete", "aria-invalid", "aria-describedby", "aria-required"], $ = ["id"], K = /* @__PURE__ */ w({
  __name: "Input",
  props: {
    modelValue: { default: "" },
    type: { default: "text" },
    label: { default: void 0 },
    placeholder: { default: void 0 },
    helperText: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    id: { default: void 0 },
    name: { default: void 0 },
    autocomplete: { default: void 0 },
    rows: { default: 3 },
    size: { default: "md" },
    class: { default: void 0 }
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { emit: I }) {
    const a = e, i = I, f = F("kori-input", a.id), { id: s, fieldDescribedBy: T, fieldInvalid: m } = N(f, a), b = u(() => `${f.value}-helper`), v = u(
      () => a.helperText || a.error ? b.value : T.value
    ), y = u(() => !!a.error || m.value), V = [
      "min",
      "max",
      "step",
      "minlength",
      "maxlength",
      "pattern",
      "inputmode",
      "autofocus",
      "list",
      "spellcheck",
      "enterkeyhint"
    ], x = A(), g = u(() => {
      const o = {};
      for (const t of V) x[t] !== void 0 && (o[t] = x[t]);
      return o;
    }), h = u(
      () => B(
        "w-full border bg-surface-default text-sm text-text-primary",
        // 40px at radius 8 is the form field; `lg` is the list-page filter field,
        // which the design draws taller and softer (44px at radius 12).
        // A textarea grows with `rows`; a fixed height cut every notes box to
        // one line whatever `rows` asked for.
        a.type === "textarea" ? "min-h-[4.5rem] rounded-lg px-3 py-2" : a.size === "lg" ? "h-11 rounded-xl px-3.5" : "h-10 rounded-lg px-3",
        "placeholder:text-text-tertiary",
        "transition-colors duration-fast",
        // The design's focus state is a 3px brand-subtle halo, not a 2px ring.
        "focus:outline-none focus-visible:ring-[3px] focus-visible:ring-brand-primary-muted focus-visible:border-brand",
        "disabled:bg-surface-sunken disabled:text-text-tertiary disabled:cursor-not-allowed",
        "read-only:bg-surface-sunken read-only:cursor-default",
        // Red for the field's own error or its FormField's, so both look the same.
        a.error || m.value ? "border-danger focus-visible:ring-danger focus-visible:border-danger" : a.success ? "border-success focus-visible:ring-success focus-visible:border-success" : "border-border-input hover:border-border-strong",
        a.class
      )
    );
    function p(o) {
      const t = o.target;
      i("update:modelValue", t.value);
    }
    return (o, t) => (l(), d("div", D, [
      e.label ? (l(), d("label", {
        key: 0,
        for: n(s),
        class: "text-sm font-medium text-text-primary"
      }, [
        C(q(e.label) + " ", 1),
        e.required ? (l(), d("span", S, "*")) : c("", !0)
      ], 8, E)) : c("", !0),
      e.type === "textarea" ? (l(), d("textarea", k({
        key: 1,
        id: n(s),
        name: e.name,
        value: e.modelValue ?? "",
        placeholder: e.placeholder,
        disabled: e.disabled,
        readonly: e.readonly,
        required: e.required,
        rows: e.rows,
        "aria-invalid": y.value || void 0,
        "aria-describedby": v.value,
        "aria-required": e.required || void 0
      }, g.value, {
        class: h.value,
        onInput: p,
        onBlur: t[0] || (t[0] = (r) => i("blur", r)),
        onFocus: t[1] || (t[1] = (r) => i("focus", r))
      }), null, 16, P)) : (l(), d("input", k({
        key: 2,
        id: n(s),
        type: e.type,
        name: e.name,
        value: e.modelValue ?? "",
        placeholder: e.placeholder,
        disabled: e.disabled,
        readonly: e.readonly,
        required: e.required,
        autocomplete: e.autocomplete,
        "aria-invalid": y.value || void 0,
        "aria-describedby": v.value,
        "aria-required": e.required || void 0
      }, g.value, {
        class: h.value,
        onInput: p,
        onBlur: t[2] || (t[2] = (r) => i("blur", r)),
        onFocus: t[3] || (t[3] = (r) => i("focus", r))
      }), null, 16, R)),
      e.error || e.helperText ? (l(), d("p", {
        key: 3,
        id: b.value,
        class: z(n(B)("text-xs", e.error ? "text-danger" : "text-text-secondary"))
      }, q(e.error || e.helperText), 11, $)) : c("", !0)
    ]));
  }
});
export {
  K as _
};
//# sourceMappingURL=Input.vue_vue_type_script_setup_true_lang-BH-0h7OD.js.map
